import $ from 'jquery'

$(document).ready(function () {
  dhsv_vc_redirect()
})

function dhsv_vc_redirect() {
  $('.dhsv_vc_redirect').each(function () {
    const redirect = $(this).data('redirect')
    const time = parseInt($(this).data('time')) * 1000

    setTimeout(function () {
      window.location.href = redirect
    }, time)
  })
}
